/* DescriptionComponent.js */

"use strict";

const BaseActivityViewColumnComponent = require("../BaseActivityViewColumnComponent");
const Renderer = require("./DescriptionRenderer");
const _ = require("lodash");

class DescriptionComponent extends BaseActivityViewColumnComponent {
    constructor(configOptions) {
        super(configOptions);

        const normalizedActivity = this._normalizeActivity(configOptions);

        this._description = _.get(normalizedActivity, "description.description", "");

        this._renderer = new Renderer(this);

        this._registerListeners();
    }
    /*******************************************/
    /* START PRIVATE COMPONENT MODEL METHODS */
    /*******************************************/
    _registerListeners() {}
    _unregisterListeners() {}
    /*******************************************/
    /* END PRIVATE COMPONENT MODEL METHODS */
    /* START PUBLIC COMPONENT MODEL METHODS */
    /*******************************************/
    get renderer() {
        return this.getRenderer();
    }
    getRenderer() {
        return this._renderer;
    }
    shutdown() {
        this._unregisterListeners();
        return this._renderer._shutdown().then(() => {
            this._renderer = undefined;
            this._description = undefined;
        });
    }
    /*******************************************/
    /* END COMPONENT MODEL METHODS */
    /* START HANDLER METHODS */
    /*******************************************/

    /*******************************************/
    /* END HANDLER METHODS */
    /* START PRIVATE METHODS */
    /*******************************************/

    /*******************************************/
    /* END PRIVATE METHODS */
    /* START PUBLIC API METHODS */
    /*******************************************/

    setValue(newVal) {
        if (!_.isUndefined(newVal.description)) {
            this.setDescription(newVal.description);
        }
    }
    getValue() {
        return {
            description: this.getDescription()
        };
    }

    setDescription(newVal) {
        this._description = newVal;
        this.emit("Description", newVal);
        return this;
    }
    getDescription() {
        return this._description;
    }

    static SortFunction(a, b) {
        let aVal = a[1].description,
            bVal = b[1].description;
        if (aVal > bVal) {
            return 1;
        }
        if (aVal < bVal) {
            return -1;
        }
        return 0;
    }

    /*******************************************/
    /* END PUBLIC API METHODS */
    /*******************************************/
}
module.exports = DescriptionComponent;
